<script setup lang="ts">
import {Head, useForm} from "@inertiajs/vue3";
import Layout from "@/Pages/auth/layouts/AuthLayout.vue";
import TextField from "@/Pages/auth/components/TextField.vue";
import FormCard from "@/Pages/auth/components/FormCard.vue";

interface Props {
    status?: string
}

defineOptions({layout: Layout})
defineProps<Props>()
const form = useForm({
    email: '',
})

const submit = () => {
    form.post(route('password.email'))
}
</script>

<template>
    <Head title="Forgot your password?" />
    <form-card
        :status="status"
        :loading="form.processing"
        :error-messages="form.errors.email"
        @submit="submit"
    >
        <template #title>
            Reset your password
        </template>
        <text-field
            v-model="form.email"
            type="email"
        >
            <template #label>
                <label class="black--text font-weight-bold text-body-2">Enter your user account's verified email address
                    and we will send you a password reset link.</label>
            </template>
        </text-field>
        <template #submit>
            Send password reset email
        </template>
    </form-card>
</template>

<style scoped>

</style>
